<script setup>
  import { ref, computed, onMounted } from 'vue';

  import Icon from "@/components/icons/Icon.vue";

  const props = defineProps({
    id: {
      type: [String, Number],
      required: true
    },
    floating: {
      type: Boolean,
      default: true
    },    
    position: {
      type: String,
      default: 'side'
    },
    alignment: {
      type: String,
      default: 'centered'
    },
    verticalAlignment: {
      type: String,
      default: 'centered'
    },
    adjustments: {
      type: [Object, String],
      required: false
    }
  })

  const userTip = ref(null);

  const displayClasses = computed(() => props.floating ? `jwc-user-tip-floating jwc-user-tip-floating-${props.position}` : 'jwc-user-tip-block');
  const styleAdjustments = computed(() => props.adjustments ? props.adjustments : null);

  onMounted(() => jwc && jwc.userTips.add(userTip.value));
</script>
<template>
  <div
    ref="userTip"
    :id='props.id' 
    data-user-tip
    class='jwc-user-tip'
    :class="displayClasses"
    :data-alignment="props.alignment"
    :data-vertical-alignment="props.position === 'side' ? props.verticalAlignment : null"
    :style="props.adjustments"
  >
    <div
      v-if="props.floating"
      class='jwc-user-tip-pointer'
    >
      <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
        <path d="M290.5 51.8C283.3 39.5 270.2 32 256 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S25.7 480 40 480H472c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368z"/>
      </svg>
    </div>
    <div class='jwc-user-tip-icon'>
      <slot name="icon">
        <Icon name="info" />
      </slot>
    </div>
    <div class='jwc-user-tip-content'>
      <header class='jwc-user-tip-header'>
        <p class='jwc-user-tip-header-text jwx-text-left'>
          <slot name="title"></slot>
        </p>
      </header>
      <div class='jwc-user-tip-body'>
        <p class="jwc-user-tip-text jwx-text-left">
          <slot name="message"></slot>
        </p>
      </div>
    </div>
    <button class='jwc-user-tip-close-button' data-user-tip-closer data-action='dismiss'>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'>
        <path d='M175 175c9.4-9.3 24.6-9.3 33.1 0l47 47.1L303 175c9.4-9.3 24.6-9.3 33.1 0 10.2 9.4 10.2 24.6 0 33.1l-46.2 47 46.2 47.9c10.2 9.4 10.2 24.6 0 33.1-8.5 10.2-23.7 10.2-33.1 0l-47.9-46.2-47 46.2c-8.5 10.2-23.7 10.2-33.1 0-9.3-8.5-9.3-23.7 0-33.1l47.1-47.9-47.1-47c-9.3-8.5-9.3-23.7 0-33.1zm337 81c0 141.4-114.6 256-256 256S0 397.4 0 256 114.6 0 256 0s256 114.6 256 256zM256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z' />
      </svg>
      <span class='sr-only'>Close this user tip.</span>
    </button>
  </div>  
</template>